import React, { useRef, useState } from 'react';
import './ServicesSection.css';
import { useNavigate } from 'react-router-dom';

const servicesData = [
    {
        id: 1,
        title: "Design",
        image: "https://dev254.kodesolution.com/edigitaal/wp-content/uploads/2025/10/service-1.png",
        description: "Creative Design and Development",
        description2: "We craft visually stunning and user-friendly designs that enhance brand identity. Our creative team focuses on modern UI/UX principles to deliver impactful digital experiences."
    },
    {
        id: 2,
        title: "Development",
        image: "https://dev254.kodesolution.com/edigitaal/wp-content/uploads/2025/10/service-2.png",
        description: "Innovative Tech Solutions",
        description2: "We build scalable and high-performance web and mobile applications using modern technologies. Our development process ensures security, speed, and reliability."
    },
    {
        id: 3,
        title: "Marketing",
        image: "https://dev254.kodesolution.com/edigitaal/wp-content/uploads/2025/10/service-1.png",
        description: "Digital Marketing Strategies",
        description2: "Our marketing strategies help businesses grow online through targeted campaigns. We focus on brand awareness, audience engagement, and measurable results."
    },
    {
        id: 4,
        title: "SEO",
        image: "https://dev254.kodesolution.com/edigitaal/wp-content/uploads/2025/10/service-2.png",
        description: "Search Engine Optimization",
        description2: "We optimize websites to rank higher on search engines and increase organic traffic. Our SEO approach includes keyword research, on-page optimization, and performance tracking."
    }
];

const ServicesSection = () => {
    const navigate = useNavigate();
    const scrollRef = useRef(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);

    // Track scroll position to update active dot
    const handleScroll = () => {
        if (!scrollRef.current) return;
        const scrollPosition = scrollRef.current.scrollLeft;
        const itemWidth = scrollRef.current.offsetWidth * 0.8; // Approximate item width influence
        const newIndex = Math.round(scrollPosition / itemWidth);
        if (newIndex !== activeIndex && newIndex < servicesData.length) {
            setActiveIndex(newIndex);
        }
    };

    const handleMouseDown = (e) => {
        setIsDragging(true);
        setStartX(e.pageX - scrollRef.current.offsetLeft);
        setScrollLeft(scrollRef.current.scrollLeft);
        // Disable snap and smooth during drag
        scrollRef.current.style.scrollSnapType = 'none';
        scrollRef.current.style.scrollBehavior = 'auto';
    };

    const handleMouseLeave = () => {
        setIsDragging(false);
        // Re-enable snap
        if (scrollRef.current) {
            scrollRef.current.style.scrollSnapType = 'x mandatory';
            scrollRef.current.style.scrollBehavior = 'smooth';
        }
    };

    const handleMouseUp = () => {
        setIsDragging(false);
        // Re-enable snap
        if (scrollRef.current) {
            scrollRef.current.style.scrollSnapType = 'x mandatory';
            scrollRef.current.style.scrollBehavior = 'smooth';
        }
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - scrollRef.current.offsetLeft;
        const walk = (x - startX) * 2; // Scroll speed multiplier
        scrollRef.current.scrollLeft = scrollLeft - walk;
    };

    const handleDotClick = (index) => {
        if (!scrollRef.current) return;
        const items = scrollRef.current.querySelectorAll('.service-card');
        if (items[index]) {
            items[index].scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center'
            });
        }
    };

    return (
        <div className="services-section">
            <h2 className="services-title">
                What We are Offering to <br />
                <span>Our Potential Client</span>
            </h2>

            <div
                className="carousel-viewport"
                ref={scrollRef}
                onScroll={handleScroll}
                onMouseDown={handleMouseDown}
                onMouseLeave={handleMouseLeave}
                onMouseUp={handleMouseUp}
                onMouseMove={handleMouseMove}
                style={{ cursor: isDragging ? 'grabbing' : 'grab' }}
            >
                <div className="carousel-track">
                    {servicesData.map((service, index) => (
                        <div
                            key={service.id}
                            className={`service-card ${index === activeIndex ? 'active' : ''}`}
                            onClick={() => setActiveIndex(index)}
                        >
                            <div className="snake-line">
                                <span></span><span></span><span></span><span></span>
                            </div>

                            <div className="service-block-style1">
                                <div className="inner-column">
                                    <div className="image-box">
                                        <img src={service.image} alt={service.title} loading="lazy" />
                                    </div>
                                    <div className="content-box">
                                        <h5 className="service-subtitle">{service.title}</h5>
                                        <h4 className="service-title-text">
                                            <a href="#!">{service.description}</a>
                                        </h4>
                                        <div className="service-details">
                                            <p>{service.description2}</p>
                                        </div>

                                        <div onClick={() => navigate('/blogs')} className="btn-box">
                                            <a className="read-more-text">Read More</a>
                                            <a className="read-more-icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                    <line x1="7" y1="17" x2="17" y2="7"></line>
                                                    <polyline points="7 7 17 7 17 17"></polyline>
                                                </svg>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="dots-container">
                {servicesData.map((_, index) => (
                     <div
                        key={index}
                        className={`dot ${index === activeIndex ? 'active' : ''}`}
                        onClick={() => handleDotClick(index)}
                    />
                ))}
            </div>
        </div>
    );
};

export default ServicesSection;
